<template>
  <div>
    <div class="mymsg_top_bar">
      <span class="mymsg_tip mymsg_tip_noac" @click="goTome">个人中心</span>
      <i class="el-icon-arrow-right"></i>
      <span class="mymsg_tip mymsg_tip_noac" @click="friends">我的好友</span>
      <i class="el-icon-arrow-right"></i>
      <span class="mymsg_tip">好友请求管理</span>
    </div>

    <div class="mymsg_con">
      <div class="mymsg_item" v-for="item in friList" :key="item.userId">
        <img class="mymsg_fri_img" src="../assets/face.jpg" />
        <div class="mymsg_item_right">
          <span class="mymsg_friend_name">{{ item.suname }}</span>
          <span class="mymsg_friend_phone">{{ item.sphone }}</span>
          <span class="friend_request_btn_area">
            <button
              @click="manageFriendRequest(item.sendUserId, 1)"
              class="friend_request_btn accept_btn"
            >
              同意
            </button>
            <button
              @click="manageFriendRequest(item.sendUserId, -1)"
              class="friend_request_btn reject_btn"
            >
              拒绝
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserFriendRequest, passOrRejectFriendRequest } from "@/api/friend";
export default {
  name: "managefriend",
  data() {
    return {
      friList: [],
      state: 1,
    };
  },
  mounted() {
    this.getFriendList();
  },
  methods: {
    friends() {
      var that = this;

      that.$router.push({ name: "friends", params: { refresh: true } });
    },
    goTome() {
      this.$router.push({ name: "me" });
    },
    tochat() {
      var that = this;
      that.$router.push({ name: "mychat", params: { refresh: true } });
    },
    getFriendList() {
      var that = this;
      getUserFriendRequest()
        .then((response) => {
          console.log(response.data);
          that.friList = response.data; // 使用搜索结果更新列表
        })
        .catch((error) => {
          console.error("获取好友列表:", error);
        });
    },
    manageFriendRequest(senduserId, state) {
      var that = this;
      console.log(senduserId);
      // 现在这个方法接收 userId 和 state 参数
      passOrRejectFriendRequest({ senduid: senduserId, state: state })
        .then((response) => {
          console.log(response);
          if (state === 1) {
            window.alert("添加好友成功");
          } else if (state === -1) {
            window.alert("拒绝好友请求成功");
          }
          that.friList = that.friList.filter(
            (item) => item.sendUserId !== senduserId
          );
        })
        .catch((error) => {
          console.error("Error managing friend request:", error);
        });
    },
  },
};
</script>

<style>
.mymsg_friend_msg {
  display: block;
  color: #999999;
  font-size: 18px;
  margin-top: 2px;
}

.mymsg_item_right {
  margin-left: 14px;
  width: 80%;
  display: grid;
  grid-template-columns: repeat(3, 50%);
}

.mymsg_item {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #cccccc;
}

.mymsg_friend_name {
  color: #333333;
  font-size: 18px;
  width: 33%;
}

.mymsg_friend_phone {
  width: 33%;
}

.friend_request_btn_area {
  right: 0;
}

.mymsg_fri_img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.mymsg_con {
  margin-top: 30px;
  background-color: white;
}

.me_msg_btn {
  color: #ffffff;
  font-size: 14px;
  margin-left: 15px;
  font-weight: 550;
  cursor: pointer;
}

.mymsg_sear_ops_con {
  display: flex;
  align-items: center;
}

.mymsg_start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: white;
  border: none;
  cursor: pointer;
}

.friend_add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.friend_add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
}

.mymsg_sear_con {
  display: flex;
  align-items: center;
}

.mymsg_sear {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mymsg_tip_noac {
  color: #707070 !important;
}

.mymsg_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.mymsg_top_bar {
  display: flex;
  align-items: center;
}
.friend_request_btn {
  margin-left: 10px;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
}

.accept_btn {
  background-color: #28a745;
  color: white;
  width: 60px;
  height: 30px;
}

.reject_btn {
  background-color: #dc3545;
  color: white;
  width: 60px;
  height: 30px;
}
</style>
